"use client";
import React, { useState, useEffect } from "react";
import ListTabRank from "./components/list-tab-rank";
import { Tabs, TabsProps } from "antd";
import { slugToOrderBy } from "@/utils/stripHtml";
import { useRouter } from "next/navigation";
interface ITabRank {
    title?: "thinh-hanh" | "doc-nhieu" | "yeu-thich" | "thao-luan" | string;
}

function TabRank({ title }: ITabRank) {
    const [innerWidth, setInnerWidth] = useState<number>(769);
    useEffect(() => {
        if (typeof window !== "undefined") {
            setInnerWidth(window.innerWidth);
        }
    }, []);
    const router = useRouter();

    const items: TabsProps["items"] = [
        // {
        //     key: "reacts",
        //     label: `Thịnh hành`,
        //     children: <ListTabRank title={type} />,
        // },
        {
            key: "read_count",
            label: `Đọc nhiều`,
            children: <ListTabRank title={title} />,
        },
        {
            key: "reviews",
            label: `Lượt đánh giá`,
            children: <ListTabRank title={title} />,
        },
        {
            key: "comments",
            label: `Bình luận`,
            children: <ListTabRank title={title} />,
        },
        {
            key: "review_point",
            label: `Đánh giá cao`,
            children: <ListTabRank title={title} />,
        },
        {
            key: "bookmarks",
            label: `Đánh dấu`,
            children: <ListTabRank title={title} />,
        },
        {
            key: "react_count",
            label: `Tương tác`,
            children: <ListTabRank title={title} />,
        },
        {
            key: "suggest_point",
            label: `Đề cử`,
            children: <ListTabRank title={title} />,
        },
        {
            key: "chapters_count",
            label: `Số chương`,
            children: <ListTabRank title={title} />,
        },
    ];
    const onChange = (key: string) => {
        router.push(`/xep-hang/${key}`, { scroll: false });
        // setType(key);
    };
    return (
        <div className="relative grid grid-cols-1 bg-white rounded-lg md:mt-[-120px] p-2 lg:p-10 lg:pt-2">
            {innerWidth > 768 && <Tabs tabPosition="left" activeKey={slugToOrderBy(title)} items={items} tabBarStyle={{ color: "black", fontWeight: "600" }} style={{ height: "fit-content" }} onChange={onChange} size="large" className="mt-10 hidden md:flex" />}
            {innerWidth < 768 && <Tabs items={items} activeKey={slugToOrderBy(title)} tabBarStyle={{ color: "black", fontWeight: "600" }} onChange={onChange} size="small" className="flex md:hidden" />}
        </div>
    );
}

export default TabRank;
